<div
    [ngClass]="visible ? 'app-help-icon-sel' : 'app-help-icon'"
    id="helpTarget"
    (click)="show($event)"
>
    <i class="far fa-headset"></i>
</div>
<dx-popover
    class="popover-toggle"
    target="#helpTarget"
    [width]="250"
    [shading]="true"
    shadingColor="rgba(0, 0, 0, 0.0)"
    [(visible)]="visible"
>
    <div *dxTemplate="let data of 'content'" class="app-help-template">
        <div (click)="hidden($event, 0)" class="app-help-voice">
            <div>Registrati e configura MySupport</div>
        </div>

        <div (click)="hidden($event, 1)" class="app-help-voice">
            <div>Apri MySupport</div>
        </div>

        <div (click)="hidden($event, 2)" class="app-help-voice">
            <div>Inizia una teleassistenza</div>
        </div>
    </div>
</dx-popover>
